import React, { useEffect, useState } from "react";

const Table = (props) => {
  const { tableHeaders = [], tableRows = [], tableClass = "" } = props;
  const classNames = tableHeaders.map((item) => item.className);
  const [tableRowsList, setTableRowsList] = useState([]);
  const [tableHeadersList, setTableHeaders] = useState([]);

  useEffect(() => {
    setTableRowsList(tableRows);
  }, [tableRows]);

  useEffect(() => {
    setTableHeaders(tableHeaders);
  }, [tableHeaders]);

  return (
    <div className="sim-table table-responsive">
      <table className={`table ${tableClass}`}>
        <thead>
          <tr>
            {tableHeadersList.map((header, i) => (
              <th key={i} className={header.className}>
                {header.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableRowsList.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row?.cellData.map((item, cellIndex) => (
                <td key={cellIndex} className={`${item.className} ${classNames[cellIndex]}`}>
                  {item.value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
